import { LANGUAGES } from '@/utils/constants'

import { REPORT_TYPES } from './report.constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export default {
  [PORTUGUESE]: {
    [REPORT_TYPES.STATS]: 'estatísticas',
    [REPORT_TYPES.REPORTS]: 'relatórios',
    [REPORT_TYPES.DATABASE]: 'base de dados',
    [REPORT_TYPES.EXPORTS]: 'exportações',
  },

  [ENGLISH]: {
    [REPORT_TYPES.STATS]: 'stats',
    [REPORT_TYPES.REPORTS]: 'reports',
    [REPORT_TYPES.DATABASE]: 'database',
    [REPORT_TYPES.EXPORTS]: 'exports',
  },

  [SPANISH]: {
    [REPORT_TYPES.STATS]: 'estadísticas',
    [REPORT_TYPES.REPORTS]: 'reportes',
    [REPORT_TYPES.DATABASE]: 'base de datos',
    [REPORT_TYPES.EXPORTS]: 'exportaciones',
  },
}
